/**
 * @fileoverview NotesTimeline - Componente para mostrar notas en formato timeline
 */

import React from 'react';
import { NotaExpanded } from '../types/collections/Nota';

interface NotesTimelineProps {
  /** Array de notas a mostrar */
  notes: NotaExpanded[];
}

/**
 * Componente para mostrar notas en formato timeline
 */
export const NotesTimeline: React.FC<NotesTimelineProps> = ({ notes }) => {
  if (!notes || notes.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-muted">No hay notas disponibles</p>
      </div>
    );
  }

  return (
    <div id="cd-timeline">
      <ul className="timeline list-unstyled">
        {notes.map((note, index) => (
          <li key={note.id || index} className="timeline-list">
            <div className="cd-timeline-content p-4">
              <h5 className="mt-0 mb-3">
                <i className="fas fa-sticky-note text-info me-2" />
                Nota #{index + 1} {index === 0 && <span className="badge bg-success ms-2">Más reciente</span>}
              </h5>
              <p className="mb-2">{note.nota}</p>
              <div className="d-flex justify-content-between align-items-center">
                <small className="text-muted">
                  <i className="fas fa-user me-1" />
                  Usuario: {note.expand?.usuario?.name || note.expand?.usuario?.email || 'N/A'}
                </small>
                <small className="text-muted">
                  <i className="fas fa-clock me-1" />
                  {note.created ? new Date(note.created).toLocaleString() : 'Fecha no disponible'}
                </small>
              </div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NotesTimeline;
